/* tslint:disable:indent */
// tslint:disable
import { Injectable } from '@angular/core';
import { AuthNoticeService, UserService } from '../../../core/_services';
import { NgxPermissionsService } from 'ngx-permissions';
import { ActivatedRoute, Router } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { interval, Subscription } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AuthService {
	private returnUrl: any = '/';
	private Permissions: any;
	private _user: any;
	private Token: string;
	private readonly REFRESH_TOKEN: string = 'refreshToken';
	private tokenUpdateSubscription: Subscription;

	constructor(
		private http: HttpClient,
		private userService: UserService,
		private permissionsService: NgxPermissionsService,
	) {
		const savedToken = localStorage.getItem('accessToken');
		const savedPermissions = localStorage.getItem('permissions');
		const savedUser = localStorage.getItem('user');
		if (savedToken && savedPermissions) {
			this.Token = savedToken;
			try {
				this.Permissions = JSON.parse(savedPermissions);
				this.permissionsService.loadPermissions(this.Permissions);
				this.permissionsService.addPermission('LOGGED_IN');
			} catch (e) {
				console.error("Failed to restore saved permissions:", e);
			}
			if (savedUser) {
				try {
					this._user = JSON.parse(savedUser);
				} catch (e) {}
			}
			this.startTokenUpdateTimer(4);
		}
	}

	getUserInfo(userName) {
		this.userService.getUser({ userName }).subscribe(data => {
			console.log(data, 'getUserInfo -data');
			this._user = data;
			this.getRolePermissions(data.role);
		}, error => {
			console.log(error, 'error');
		});
	}

	getRolePermissions(roleId) {
		localStorage.setItem('role', roleId)
		this.userService.getRole(roleId).subscribe(data => {
			console.log(data, 'getRolePermissions -data');
			this.Permissions = data.permissions;
			this.permissionsService.loadPermissions(data.permissions);
			this.permissionsService.addPermission('LOGGED_IN');
			this.startTokenUpdateTimer(4);
		}, error => {
			console.log(error, 'error');
		});
	}

	public getUserInfoANDRolePermissions({ userName }): Observable<any> {
		return this.userService.getUser({ userName }).pipe(
			switchMap(data => {
				this._user = data;
				return this.userService.getRole(data.role);
			})
		);
	}

	public fetchUserContext(token: string): Observable<any> {
		const authUrl = environment.urls.api.auth || 'https://finbase-api.staging.arth.bz';
		const headers = new HttpHeaders({
			'Authorization': `Bearer ${token}`
		});
		return this.http.get(`${authUrl}/api/v1/iam/me/`, { headers });
	}

	public mapPermissionsToLegacy(permissions: string[]): string[] {
		const legacyPermissions: string[] = [];
		const mapping: { [key: string]: string[] } = {
			// LMS Module (loan)
			"loan.view_list": ["VIEW_LOAN_LIST", "VIEW_LOAN_SUB_LIST", "VIEW_LISTING", "SEARCH_LOAN"],
			"loan.view_details": [
				"VIEW_LOAN_DETAILS", 
				"VIEW_LOAN_CARD", 
				"VIEW_SOA", 
				"VIEW_LOAN_AGREEMENT", 
				"VIEW_LOAN_TNC", 
				"VIEW_KYC", 
				"VIEW_CREDIT", 
				"VIEW_REPAYMENT", 
				"VIEW_BANK_DETAILS", 
				"VIEW_ACTIVITY_HISTORY",
				"VIEW_LOAN_NOC",
				"VIEW_BUSINESS_PRIME",
				"REPAYMENT_LINK"
			],
			"loan.wo_panel": ["WO_PANEL"],
			"loan.download": ["DOWNLOAD_LOAN"],
			"loan.create": ["CREATE_LOAN"],
			"loan.view_loan_tnc": ["VIEW_LOAN_TNC"],
			
			// Risk / KYC
			"kyc.verify_reject": ["KYC_VERIFY_REJECT", "KYC_REUPLOAD"],
			"kyc.approve_disbursal": ["KYC_APPROVE_REJECT"],
			"payee.validate": ["VALIDATE_PAYEE"],
			"tab.kyc.view": ["VIEW_KYC"],
			
			// Tabs
			"tab.repayment.view": ["VIEW_REPAYMENT"],
			"tab.bank_details.view": ["VIEW_BANK_DETAILS"],
			"tab.activity_history.view": ["VIEW_ACTIVITY_HISTORY"],
			
			// Reports Module
			"report.disbursement": ["VIEW_DISBURSEMENT_REPORTS", "DOWNLOAD_DISBURSEMENT_REPORTS", "VIEW_REPORT_RECON", "DOWNLOAD_REPORT_RECON"],
			"report.repayment": ["VIEW_REPORT_REPAYMENT", "DOWNLOAD_REPAYMENT"],
			"report.interest": ["VIEW_REPORT_INTREST", "DOWNLOAD_REPORT_INTREST"],
			"report.crif": ["VIEW_REPORT_CRIF", "DOWNLOAD_REPORT_CRIF"],
			
			// CRM Module (Customer)
			"customer.view_list": ["VIEW_CUSTOMER_LIST"],
			"customer.view_details": ["VIEW_CUSTOMER_DETAILS"],
			"customer.download": ["DOWNLOAD_CUSTOMER"],
			"customer.update": ["Change-Request"],
			
			// Partner & Lender Config
			"partner.create": ["ADD_PARTNER"],
			"partner.view": ["VIEW_PARTNER"],
			"partner.download": ["DOWNLOAD_PARTNER"],
			
			"product.create": ["ADD_PRODUCT"],
			"product.view": ["VIEW_PRODUCT"],
			"product.download": ["DOWNLOAD_PRODUCT"],
			
			"lender.create": ["ADD_LENDER", "LENDER_PAYMENT_UPLOADS"],
			"lender.view": ["VIEW_LENDER", "DOWNLOAD_LENDER", "LENDER_PAYMENT_UPLOADS"],
			"lender.update": ["LENDER_PAYMENT_UPLOADS"],
			
			"tnc.create": ["ADD_TNC"],
			"tnc.view": ["VIEW_TNC"],
			
			"uploads.add": ["ADD_UPLOADS"],
			"digital_uploads.create": ["ADD_UPLOADS"],
			"task_upload.create": ["ADD_UPLOADS"],
			
			"userrole.manage": ["USER_ROLE_MANAGEMENT"],
			"role.view": ["USER_ROLE_MANAGEMENT"],
			"user.view": ["USER_ROLE_MANAGEMENT"],
			"role.create": ["USER_ROLE_MANAGEMENT"],
			
			// Distributor Trade / ARTH Portal
			"portal.view": ["VIEW_PORTAL"],
			"arth_portal.view": ["VIEW_PORTAL"],
			"cohort.view": ["VIEW_COHORTS", "DOWNLOAD_COHORTS", "ADD_COHORTS"],
			"arth_portal.view_cohorts": ["VIEW_COHORTS"],
			"arth_portal.download_cohorts": ["DOWNLOAD_COHORTS"],
			"arth_portal.add_cohorts": ["ADD_COHORTS"],
			"prequalification.view": ["VIEW_PREQUALIFICATION"],
			"arth_portal.view_prequalification": ["VIEW_PREQUALIFICATION"],
			"accounttransfer.view": ["ACCOUNT_TRANSFER"],
			"arth_portal.account_transfer": ["ACCOUNT_TRANSFER"],
			"payment.view": ["VIEW_PAYMENTS", "DOWNLOAD_PAYMENTS", "ADD_PAYMENTS"],
			"arth_portal.view_payments": ["VIEW_PAYMENTS"],
			"arth_portal.download_payments": ["DOWNLOAD_PAYMENTS"],
			"arth_portal.add_payments": ["ADD_PAYMENTS"],
			"paymintdevice.view": ["PAYMINT_DEVICE"],
			"arth_portal.paymint_device": ["PAYMINT_DEVICE"],
			"paymentadvice.view": ["VIEW_PAYMENT_ADVICE"],
			"arth_portal.view_customers": ["VIEW_CUSTOMERS"],
			"arth_portal.download_customers": ["DOWNLOAD_CUSTOMERS"],
			"arth_portal.add_customers": ["ADD_CUSTOMERS"],
			"ovc.loan_noc": ["VIEW_LOAN_NOC"],
		};

		permissions.forEach(perm => {
			legacyPermissions.push(perm); // keep original code
			if (mapping[perm]) {
				mapping[perm].forEach(legacyPerm => {
					if (!legacyPermissions.includes(legacyPerm)) {
						legacyPermissions.push(legacyPerm);
					}
				});
			}
		});

		return legacyPermissions;
	}

	public setPermissions(data: any) {
		this.Permissions = data.permissions;
		this.permissionsService.loadPermissions(data.permissions);
		this.permissionsService.addPermission('LOGGED_IN');
	}

	public setTokens(data) {
		const refreshToken = data.RefreshToken;
		this.Token = data.IdToken;
	}

	public get user() {
		return this._user;
	}

	public set user(value: any) {
		this._user = value;
	}

	public get permissions() {
		return this.Permissions;
	}

	public set permissions(value: any) {
		this.Permissions = value;
	}

	public get token() {
		return this.Token;
	}

	public refreshToken(minutes: number) {
		return new Observable<any>(
			subscriber => {
				interval(1000 * 60 * minutes).subscribe(x => {
					const refreshToken = localStorage.getItem(this.REFRESH_TOKEN);
					if (refreshToken) {
						this.userService.getTokens(refreshToken).subscribe(response => {
							subscriber.next(response);
						}, err => {
							console.error("Failed to refresh token automatically:", err);
						});
					}
				});
			}
		);
	}

	public startTokenUpdateTimer(time: number = 4) {
		if (this.tokenUpdateSubscription) {
			this.tokenUpdateSubscription.unsubscribe();
		}
		this.tokenUpdateSubscription = this.refreshToken(4).subscribe(data => {
			if (data && data.access) {
				const token = {
					IdToken: data.access,
					RefreshToken: data.refresh || localStorage.getItem(this.REFRESH_TOKEN)
				};
				this.setTokens(token);
				localStorage.setItem('accessToken', data.access);
				if (data.refresh) {
					localStorage.setItem(this.REFRESH_TOKEN, data.refresh);
				}
			}
		});
	}
}
